import { Box, Typography } from '@material-ui/core'
import NextPager from '../../components/NextPager'
import SiteStatusDropDown from '../../components/SiteStatusDropDown'
import SiteButtonsLayout from '../SiteButtonsLayout'
import { useStyles } from './styles'
const SiteList = (props) => {
  const {
    sites,
    status,
    setStatus,
    totalcount,
    setPage,
    page,
    selected,
    setSelected,
  } = props
  const classes = useStyles()
  return (
    <div className={classes.layout}>
      <SiteStatusDropDown
        status={status}
        setStatus={setStatus}
        setPage={setPage}
      ></SiteStatusDropDown>
      <Typography variant="subtitle1" align="left" className={classes.text}>
        Applications by Site ID
      </Typography>
      {sites.length ? (
        <>
          <SiteButtonsLayout
            selected={selected}
            setSelected={setSelected}
            sites={sites}
          ></SiteButtonsLayout>
          <NextPager
            page={page}
            setPage={setPage}
            totalcount={totalcount}
          ></NextPager>{' '}
        </>
      ) : (
        <Box className={classes.nosites}>
          {' '}
          <Typography variant="caption" className={classes.nositestext}>
            No Sites yet
          </Typography>
        </Box>
      )}
    </div>
  )
}
export default SiteList
